import { ReactNode, useEffect } from 'react';

import { Box } from '@mui/material';
import { NavDrawer, PageWrapper, WelcomeScreen } from '@components';
import { useWelcomeScreen } from '@hooks';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { fetchPositions } from '@redux/positions';
import { selectPermissions } from '@redux/accounts';
import { hasPermission } from '@constants';
import { navRailBreakpoint } from '@theme/variables';

export const AppLayout = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch();
  const showWelcomeScreen = useWelcomeScreen();
  const selectedAccountId = useAppSelector((state) => state.accounts.selected);
  const permissions = useAppSelector(selectPermissions);
  const canReadHiring = hasPermission(permissions, 'H:R');

  useEffect(() => {
    if (canReadHiring) dispatch(fetchPositions());
  }, [dispatch, selectedAccountId, canReadHiring]);

  if (showWelcomeScreen) {
    return (
      <PageWrapper>
        <WelcomeScreen />
      </PageWrapper>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100dvh',
      }}
      display="flex"
      flexDirection={{ xs: 'column', [navRailBreakpoint]: 'row' }}
    >
      <NavDrawer />
      <Box flex={1} minWidth={0}>
        {children}
      </Box>
    </Box>
  );
};
